
const digest = '5553c8b827a60a5cc7719b463de250b66dad9e6891ce3f43b82dd6e95971477b';
const classes = {"wrapper":"_wrapper_1hgyz_1","input":"_input_1hgyz_6","errorMessage":"_errorMessage_1hgyz_29","invalid":"_invalid_1hgyz_35","disabled":"_disabled_1hgyz_39","withAudioRight":"_withAudioRight_1hgyz_44","withAudioLeft":"_withAudioLeft_1hgyz_48"};
const css = `._wrapper_1hgyz_1 {
  margin-bottom: 10px;
  position: relative;
}

._input_1hgyz_6 {
  height: auto;
  border: 1px solid #e2e5ed !important;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
  line-height: 20px;
  width: 100%;
  display: block;
}
._input_1hgyz_6:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}

._errorMessage_1hgyz_29 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: red;
}

._invalid_1hgyz_35 {
  border-color: red !important;
}

._disabled_1hgyz_39 {
  background-color: #f3f3f3;
  opacity: 1;
}

._withAudioRight_1hgyz_44 ._input_1hgyz_6 {
  padding: 16px 40px 16px 20px;
}

._withAudioLeft_1hgyz_48 ._input_1hgyz_6 {
  padding: 16px 20px 16px 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  